import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import DefaultAvatar from 'components/controls/DefaultAvatar';

import styles from './Avatar.scss';

export default function Avatar(props) {
  const {
    src,
    alt,
    size,
    className,
    ...restProps
  } = props;
  const avatarProps = {
    className: classnames(
      styles.avatar,
      className,
      styles[size],
    ),
    ...restProps
  }

  if (!src || !src.length) {
    return (
      <DefaultAvatar
        {...avatarProps}
      />
    )
  }

  return (
    <img
      src={src}
      alt={alt}
      {...avatarProps}
    />
  )
}

Avatar.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  size: PropTypes.oneOf([
    'small',
    'medium',
    'large',
  ]),
  className: PropTypes.string,
};

Avatar.defaultProps = {
  src: null,
  alt: 'avatar',
  className: null,
  size: 'medium',
};



// WEBPACK FOOTER //
// ./src/components/controls/Avatar.jsx